import { render } from "./ListeDetachementPage.vue?vue&type=template&id=499923e5&ts=true"
import script from "./ListeDetachementPage.vue?vue&type=script&lang=ts"
export * from "./ListeDetachementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__